import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import CandidateContext from "./CandidateContext";
import EliteJobContext from "../EliteJobContext/EliteJobContext";
import UpperbarContext from "../../context/upperbar-context";
import AuthContext from "../../context/auth-context";
import { Fetchdata } from "../../hooks/getData";
import $ from "jquery";
function CandidateState(props) {
  const { appURL } = useContext(UpperbarContext);
  const { User } = useContext(AuthContext);
  const { getJobList } = useContext(EliteJobContext);

  const [loading, setLoading] = useState(true);
  const [originalList, setOriginalList] = useState(null);

  const [chooseJob, setChooseJob] = useState("-1");
  const [chooseStatus, setChooseStatus] = useState("-1");
  const [chooseVia, setChooseVia] = useState("-1");

  // for CV
  const [isCVUploaded, setIsCVUploaded] = useState(false);
  const [typeCVFile, setTypeCVFile] = useState();
  const [cvFile, setCVFile] = useState("");
  const cvExt = cvFile.split(".").pop();

  // for COVER LETTER
  const [isCoverUploaded, setIsCoverUploaded] = useState(false);
  const [typeCoverFile, setTypeCoverFile] = useState();
  const [coverFile, setCoverFile] = useState("");
  const coverExt = coverFile.split(".").pop();
  const [closeChecked, setCloseChecked] = useState(false);

  const candidateValue = {
    name: "",
    contactno: "",
    email: "",
    message: "",
    cvtype: "",
    cv: "",
    covertype: "",
    cover: "",
    via: "",
    job: "",
    jobStatus: "",
    cvRadio: "cvFile",
    coverRadio: "coverFile",
    via: "",
  };

  const [candidateFormValue, setCandidateFormValue] = useState(candidateValue);
  const [candidateFormError, setCandidateFormError] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const [popup, setPopup] = useState(false);
  const togglePopup = () => {
    setPopup(!popup);
  };

  const [viewPop, setViewPop] = useState(false);
  const toggleViewPopup = () => {
    setViewPop(!viewPop);
  };
  //API to create log book

  const fetchdata = () => {
    const dataForm = {
      ComID: User.ComID,
      Flag: "i",
      UserID: User.UID.toString(),
      MemID: User.UID.toString(),
      JobID: tableData.JobID ? tableData.JobID.toString() : "",
      // JobID: candidateFormValue.job,
      // JobStatus: candidateFormValue.jobStatus,
      Name: candidateFormValue.name,
      Contact: candidateFormValue.contactno,
      Email: candidateFormValue.email,
      Message: candidateFormValue.message,
      CVType: candidateFormValue.cvRadio === "cvUrl" ? "U" : "F",
      CV:
        candidateFormValue.cvRadio === "cvFile" && typeCVFile !== null
          ? typeCVFile.split(",")[1]
          : candidateFormValue.cv,

      Cover:
        candidateFormValue.coverRadio === "coverFile" && typeCoverFile !== null
          ? typeCoverFile.split(",")[1]
          : candidateFormValue.cover,

      CoverType: coverFile ? "F" : "",
      // CoverType: candidateFormValue.coverRadio === "coverUrl" ? "U" : "F",
      Via: "M",
      FetchURL: `${appURL}api/admin/job-candidate`,
      Type: "POST",
    };

    Fetchdata(dataForm).then(function (result) {
      if (result.StatusCode === 200) {
        getCandidateList();
        $(".addCandidateFormBg").fadeOut(500);
        $(".addCandidateForm").fadeOut(500);
        setPopup(false);
        getJobList();
        toast.success(result.Message, {
          style: {
            color: "green",
            fontSize: "13px",
          },
          theme: "light",
        });
      } else {
        toast.error("Error: " + result.Message, {
          style: {
            color: "red",
            fontSize: "13px",
          },
          theme: "light",
        });
      }
    });
  };
  // API for log book List
  const [candidateList, setCandidateList] = useState([]);
  const [tableData, setTableData] = useState("");
  useEffect(() => {
    getCandidateList();
  }, [tableData]);

  const getCandidateList = () => {
    const params = {
      ComID: User.ComID,
      Flag: "S",
      UserID: User.UID.toString(),
      MemID: "-1",
      JobID: tableData.JobID && tableData.JobID.toString(),
      // JobID: chooseJob.toString(),
      // JobID: "-1",
      JobStatus: "-1",
      Via: "-1",
      // JobStatus: chooseStatus,
      // Via: chooseVia,
      Type: "POST",
      FetchURL: `${appURL}api/admin/job-candidate`,
    };

    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.Values ? result.Values : "";
        setLoading(false);
        setCandidateList(postResult);
        setOriginalList(postResult);
      } else {
        setLoading(false);
        setCandidateList([]);
        setOriginalList([]);
      }
    });
  };

  ///// FOR View
  const [viewId, setViewId] = useState("");
  const handleView = (data) => {
    setViewPop(true);
    setViewId(data.CandidateID);
    $(".viewCandidateBg").fadeIn(500);
    $(".viewCandidate").fadeIn(500);
  };

  const [viewCandidate, setViewCandidate] = useState([]);

  useEffect(() => {
    viewCandidateList();
  }, [viewId]);

  const viewCandidateList = () => {
    const params = {
      ComID: User.ComID,
      Flag: "SI",
      UserID: User.UID.toString(),
      CandidateID: viewId.toString(),
      Type: "POST",
      FetchURL: `${appURL}api/admin/job-candidate`,
    };

    Fetchdata(params).then(function (result) {
      if (result.StatusCode === 200) {
        const postResult = result.Values ? result.Values[0] : "";
        setViewCandidate(postResult);
      } else {
        setViewCandidate([]);
      }
    });
  };

  // //Everything to pop up and delete the notification list
  const [deletePopup, setDeletePopup] = useState({
    show: false, // initial values set to false and null
    data: null,
  });

  const [delId, setDelId] = useState("");

  const handleDelete = async (datas) => {
    setDeletePopup({
      show: true,
    });
    setDelId(datas.CandidateID);
  };

  // This will perform the deletion and hide the Confirmation Box

  const handleDeleteTrue = async () => {
    const dataForm = {
      ComID: User.ComID,
      Flag: "R",
      UserID: User.UID.toString(),
      CandidateID: delId.toString(),
    };

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", Signature: "p0m76" },
      body: JSON.stringify(dataForm),
    };
    fetch(`${appURL}api/admin/job-candidate`, requestOptions).then((result) => {
      result.json().then((resp) => {
        if (resp.StatusCode === 200) {
          getCandidateList();
          getJobList();
          toast.success(result.Message, {
            style: {
              color: "green",
              fontSize: "13px",
            },
            theme: "light",
          });
        } else {
          toast.error("Error: " + result.Message, {
            style: {
              color: "red",
              fontSize: "13px",
            },
            theme: "light",
          });
        }
      });
    });
    setDeletePopup({
      show: false,
      data: null,
    });
  };

  // This will just hide the Confirmation Box when user clicks "No"/"Cancel"

  const handleDeleteFalse = () => {
    setDeletePopup({
      show: false,
      data: null,
    });
  };

  // Ends Here

  return (
    <CandidateContext.Provider
      value={{
        loading,
        originalList,
        deletePopup,
        handleDeleteTrue,
        handleDeleteFalse,
        handleDelete,
        popup,
        setPopup,
        togglePopup,
        candidateList,
        setCandidateList,
        candidateFormValue,
        setCandidateFormValue,
        candidateFormError,
        setCandidateFormError,
        isSubmit,
        candidateValue,
        setIsSubmit,

        closeChecked,
        setCloseChecked,

        fetchdata,
        viewPop,
        setViewPop,
        toggleViewPopup,

        isCVUploaded,
        setIsCVUploaded,
        setTypeCVFile,
        typeCVFile,
        cvFile,
        setCVFile,

        isCoverUploaded,
        setIsCoverUploaded,
        setTypeCoverFile,
        typeCoverFile,
        coverFile,
        setCoverFile,
        handleView,

        viewCandidate,
        setViewCandidate,

        chooseJob,
        chooseStatus,
        chooseVia,
        setChooseJob,
        setChooseStatus,
        setChooseVia,
        tableData,
        setTableData,
      }}
    >
      {props.children}
    </CandidateContext.Provider>
  );
}

export default CandidateState;
